module.exports = __webpack_public_path__ + "static/ud_co_workers-578b9fd519c4dae519e0c347edb3b83b.svg";